import { createAction, props } from '@ngrx/store';
import { ZoneGroup } from 'src/app/zones/models/zone-group';

export const getZoneSubscriptionGroupsSuccess = createAction(
  '[ZonesSubscriptionGroups/API] Get Zones Subscription Groups Success',
  props<{data: ZoneGroup[]}>()
);
export const getZoneSubscriptionGroupsFailure = createAction(
  '[ZonesSubscriptionGroups/API] Get Zones Subscription Groups Failure',
  props<{error: any}>()
);

export const createZoneSubscriptionGroupSuccess = createAction(
  '[ZonesSubscriptionGroups/API] Create Zones Subscription Groups Success',
  props<{data: ZoneGroup}>()
);
export const createZoneSubscriptionGroupFailure = createAction(
  '[ZonesSubscriptionGroups/API] Create Zones Subscription Groups Failure',
  props<{error: any}>()
);

export const editZoneSubscriptionGroupSuccess = createAction(
  '[ZonesSubscriptionGroups/API] Update Zones Subscription Groups Success',
  props<{data: ZoneGroup}>()
);
export const editZoneSubscriptionGroupFailure = createAction(
  '[ZonesSubscriptionGroups/API] Update Zones Subscription Groups Failure',
  props<{error: any}>()
);

export const assignZoneToZoneSubscriptionGroupSuccess = createAction(
  '[ZonesSubscriptionGroups/API] Assign zone to Zone Subscription Group Success',
  props<{data: ZoneGroup}>()
);
export const assignZoneToZoneSubscriptionGroupFailure = createAction(
  '[ZonesSubscriptionGroups/API]  Assign zone to Zone Subscription Group Failure',
  props<{error: any}>()
);

export const unassignZoneToZoneSubscriptionGroupSuccess = createAction(
  '[ZonesSubscriptionGroups/API] Unassign zone to Zone Subscription Group Success',
  props<{data: ZoneGroup}>()
);
export const unassignZoneToZoneSubscriptionGroupFailure = createAction(
  '[ZonesSubscriptionGroups/API]  Unassign zone to Zone Subscription Group Failure',
  props<{error: any}>()
);

export type ZonesSubscriptionGroupsApiActionsUnion = ReturnType<
  typeof getZoneSubscriptionGroupsSuccess |
  typeof getZoneSubscriptionGroupsFailure |
  typeof createZoneSubscriptionGroupSuccess |
  typeof createZoneSubscriptionGroupFailure |
  typeof editZoneSubscriptionGroupSuccess |
  typeof editZoneSubscriptionGroupFailure|
  typeof assignZoneToZoneSubscriptionGroupSuccess |
  typeof assignZoneToZoneSubscriptionGroupFailure |
  typeof unassignZoneToZoneSubscriptionGroupSuccess |
  typeof unassignZoneToZoneSubscriptionGroupFailure
  >;
